import styled from 'styled-components'

export const StyledCalloutBadge = styled.div`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
`
